
import React from "react";
import { month } from "./months";
import { upperPlanType } from "./utilities";

const Clients = (props) => {
 
    const {currentClient, name, planType } = props;

    return (    
        <div className="pair-list">
            <header>
              <div className="col-sm-1">ID</div>
              <div className="col-sm-3">会社名</div>
              <div className="col-sm-2">プラン</div>
              <div className="col-sm-3"></div>
              <div className="col-sm-3">{month}月請求予定数</div>
            </header>
			{currentClient
				.filter((value) => {
					if (name === "" ) {	
						return value;
					} else if (
					(typeof name.toLowerCase() === "string" &&
						value.name.toLowerCase().includes(name))
					) {
						return value;
					}
				})
				.filter((value) => {
					if (planType.toLowerCase() === "") {
						return value;
					} else if (
						value.planType.toLowerCase() === planType.toLowerCase()
					) {
						return value;
					}
				})
				.map((client, index) => {
					return (
					<section key={index}>
						<div className="col-sm-1"> 
							{client.id}
						</div>
						<div className="col-sm-3"><a href={`/desk/clients/${client.id}`}>{client.name}</a></div>
						<div className="col-sm-2">{upperPlanType(client.planType)}</div>
						<div className="col-sm-3">
							<a className="btn btn-light btn-sm" href={`/desk/clients/${client.id}/users`}>ユーザ:{client.usersCount}名</a>
							<a className="btn btn-light btn-sm" href={`/desk/clients/${client.id}/employees`}>
								従業員{client.employeesCount}名
							</a>
						</div>
						<div className="col-sm-2">
							{/* Billing target section. In Thailand, there is no information and function related to payment information data.*/}
						</div>
						<div className="col-sm-1 text-right">
							<a className="btn btn-primary btn-sm"href={`/desk/clients/${client.id}/edit/`}>
								詳細
							</a>
						</div>
					</section>
				);
			})}
		</div>
    );
}


export default Clients;